module.exports = __webpack_public_path__ + "img/4.cbdcf945.png";